import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from './locales/en/common.json';
import homeEN from './locales/en/home.json';
import industriesEN from './locales/en/industries.json';
import capabilitiesEN from './locales/en/capabilities.json';
import aiAgentsEN from './locales/en/aiAgents.json';
import enterpriseAIEN from './locales/en/enterpriseAI.json';
import aiGovernanceEN from './locales/en/aiGovernance.json';
import clienteleEN from './locales/en/clientele.json';
import aboutEN from './locales/en/about.json';
import contactEN from './locales/en/contact.json';
import privacyEN from './locales/en/privacy.json';
import termsEN from './locales/en/terms.json';
import platformEN from './locales/en/platform.json';
import applicationsEN from './locales/en/applications.json';
import knowledgeHubEN from './locales/en/knowledgeHub.json';
import aiInvestigationEN from './locales/en/aiInvestigation.json';
import aiDataBridgeEN from './locales/en/aiDataBridge.json';

import commonBM from './locales/bm/common.json';
import homeBM from './locales/bm/home.json';
import industriesBM from './locales/bm/industries.json';
import capabilitiesBM from './locales/bm/capabilities.json';
import aiAgentsBM from './locales/bm/aiAgents.json';
import enterpriseAIBM from './locales/bm/enterpriseAI.json';
import aiGovernanceBM from './locales/bm/aiGovernance.json';
import clienteleBM from './locales/bm/clientele.json';
import aboutBM from './locales/bm/about.json';
import contactBM from './locales/bm/contact.json';
import privacyBM from './locales/bm/privacy.json';
import termsBM from './locales/bm/terms.json';
import platformBM from './locales/bm/platform.json';
import applicationsBM from './locales/bm/applications.json';
import knowledgeHubBM from './locales/bm/knowledgeHub.json';
import aiInvestigationBM from './locales/bm/aiInvestigation.json';
import aiDataBridgeBM from './locales/bm/aiDataBridge.json';

import commonZH from './locales/zh/common.json';
import homeZH from './locales/zh/home.json';
import industriesZH from './locales/zh/industries.json';
import capabilitiesZH from './locales/zh/capabilities.json';
import aiAgentsZH from './locales/zh/aiAgents.json';
import enterpriseAIZH from './locales/zh/enterpriseAI.json';
import aiGovernanceZH from './locales/zh/aiGovernance.json';
import clienteleZH from './locales/zh/clientele.json';
import aboutZH from './locales/zh/about.json';
import contactZH from './locales/zh/contact.json';
import privacyZH from './locales/zh/privacy.json';
import termsZH from './locales/zh/terms.json';
import platformZH from './locales/zh/platform.json';
import applicationsZH from './locales/zh/applications.json';
import knowledgeHubZH from './locales/zh/knowledgeHub.json';
import aiInvestigationZH from './locales/zh/aiInvestigation.json';
import aiDataBridgeZH from './locales/zh/aiDataBridge.json';

const resources = {
  en: {
    common: commonEN,
    home: homeEN,
    industries: industriesEN,
    capabilities: capabilitiesEN,
    aiAgents: aiAgentsEN,
    enterpriseAI: enterpriseAIEN,
    aiGovernance: aiGovernanceEN,
    clientele: clienteleEN,
    about: aboutEN,
    contact: contactEN,
    privacy: privacyEN,
    terms: termsEN,
    platform: platformEN,
    applications: applicationsEN,
    knowledgeHub: knowledgeHubEN,
    aiInvestigation: aiInvestigationEN,
    aiDataBridge: aiDataBridgeEN
  },
  bm: {
    common: commonBM,
    home: homeBM,
    industries: industriesBM,
    capabilities: capabilitiesBM,
    aiAgents: aiAgentsBM,
    enterpriseAI: enterpriseAIBM,
    aiGovernance: aiGovernanceBM,
    clientele: clienteleBM,
    about: aboutBM,
    contact: contactBM,
    privacy: privacyBM,
    terms: termsBM,
    platform: platformBM,
    applications: applicationsBM,
    knowledgeHub: knowledgeHubBM,
    aiInvestigation: aiInvestigationBM,
    aiDataBridge: aiDataBridgeBM
  },
  zh: {
    common: commonZH,
    home: homeZH,
    industries: industriesZH,
    capabilities: capabilitiesZH,
    aiAgents: aiAgentsZH,
    enterpriseAI: enterpriseAIZH,
    aiGovernance: aiGovernanceZH,
    clientele: clienteleZH,
    about: aboutZH,
    contact: contactZH,
    privacy: privacyZH,
    terms: termsZH,
    platform: platformZH,
    applications: applicationsZH,
    knowledgeHub: knowledgeHubZH,
    aiInvestigation: aiInvestigationZH,
    aiDataBridge: aiDataBridgeZH
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'bm', 'zh'],
    defaultNS: 'common',
    ns: ['common', 'home', 'industries', 'capabilities', 'aiAgents', 'enterpriseAI', 'aiGovernance', 'clientele', 'about', 'contact', 'privacy', 'terms', 'platform', 'applications', 'knowledgeHub', 'aiInvestigation', 'aiDataBridge'],
    
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0
    },
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n;
